import { gql } from '@apollo/client';

const UPDATE_STUDY_PATIENT_INSURANCE = gql`
  mutation updateStudyPatientInsurance($input: UpdateStudyPatientInsuranceInput!) {
    updateStudyPatientInsurance(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_STUDY_PATIENT_INSURANCE;
